import gql from "graphql-tag";
export default {
  login: gql`
    mutation($email: String!, $password: String!) {
      login(data: { email: $email, password: $password, remember: true }) {
        token
        user {
          id
          msAccessToken
        }
      }
    }
  `,
};
